import { useAfterpayScript } from '../hooks/useAfterpayScript';
import useAfterpay from '../hooks/useAfterpay';
import { useEffect } from 'react';
import { clearMessagingPlacements } from '../helpers';

export const AfterpayMessaging = (): null => {
  const { isAfterpayReady, createPlacement } = useAfterpayScript();
  const { isAfterpayEnabled } = useAfterpay();

  useEffect(() => {
    clearMessagingPlacements();

    if (isAfterpayEnabled) {
      const attributes = {
        amountSelector: '.afterpay-price-selector-mini-cart',
        size: 'xs',
        logoType: 'lockup',
        styles: {
          fontFamily: 'Arial',
          textColor: 'red'
        }
      };
      createPlacement('#afterpay-messaging-widget', attributes);
    }
  // TODO: Refactor this dependency
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAfterpayReady, isAfterpayEnabled]);

  return null;
};
